"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { ComponentProps } from "react";
import type { FieldError } from "react-hook-form";

import { cn } from "@homeinstead/ui";
import { FormError } from "@homeinstead/ui/components/FormError";
import { useId } from "react";
import { InquiryFieldLabel } from "./InquiryFieldLabel";

type InquiryTextareaFieldProps = Omit<
  ComponentProps<"textarea">,
  "className"
> & {
  className?: string;
  error?: FieldError;
  errorClassName?: string;
  label?: string;
  showError: boolean;
  textColor?: TextColor;
};

function InquiryTextareaField({
  className,
  error,
  errorClassName,
  id: idProp,
  label,
  showError,
  textColor,
  ...textareaProps
}: InquiryTextareaFieldProps) {
  const generatedId = useId();
  const id = idProp ?? generatedId;

  return (
    <div className="flex flex-col gap-2">
      {label ? (
        <InquiryFieldLabel htmlFor={id} textColor={textColor}>
          {label}
        </InquiryFieldLabel>
      ) : null}
      <textarea
        className={cn(
          "min-h-28 w-full resize-y rounded-sm border border-new-beginnings-base bg-white px-3 py-3 text-base text-new-beginnings-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-new-beginnings-base disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        id={id}
        {...textareaProps}
      />
      {showError ? (
        <FormError.span className={errorClassName}>
          {error?.message}
        </FormError.span>
      ) : null}
    </div>
  );
}

export { InquiryTextareaField };
